// context/FileContext.js
import React, { createContext, useContext, useState } from 'react';

const FileContext = createContext();

export function FileProvider({ children }) {
  const [fileStore, setFileStore] = useState({});

  const addUploadedFileDetails = ({ fileName, data }) => {
    setFileStore(prev => ({ ...prev, [fileName]: data }));
  };

  const getFileData = (fileName) => {
    return fileStore[fileName] || [];
  };

  return (
    <FileContext.Provider value={{ fileStore, addUploadedFileDetails, getFileData }}>
      {children}
    </FileContext.Provider>
  );
}

export const useFileContext = () => useContext(FileContext);
